module.exports = __webpack_public_path__ + "static/media/icon_xiajiant.18f9f9eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_xiajiant.png
// module id = 774
// module chunks = 0